import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import TopicTile from './TopicTile';
import Quizze from './Quizze';
import Hint from '../Crosspage/Hint';
import { useTranslation } from 'react-i18next';

export default function QuizzeOverview(props) {

    const {i18n, t} = useTranslation();

    const hint = 
        <Paper sx={{maxWidth: 800, p: 2, m: 1}}>
            <Typography align="left" sx={{mb: 1}}>
            {t("welcome", { website: "Gekonnt hanDeln" })}
            </Typography>
            <Typography align="left">
                {t("welcomeQuizText1")}
            </Typography> 
        </Paper>

    const renderQuizparts = () => {

        const quizpartJS = [];

        for (let quizpart of props.quizparts) {
            const subtopics = props.subtopics.filter(topic => topic.quizpartId === quizpart.id)
            quizpartJS.push(
                <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", m: 2}} key={quizpart.id}>
                    <TopicTile title={quizpart.name[i18n.language]} img={quizpart.imageSource} quizpartId={quizpart.id}
                        quizProgress={props.quizProgress} key={quizpart.id} subtopics={subtopics}
                    />
                    <Quizze quizpart={quizpart} subtopics={subtopics} quizProgress={props.quizProgress}/>
                </Box>
            )
        }

        return quizpartJS;
    }


    return(
        props.quizparts &&
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Paper sx={{width: "16rem", mb: 2, mt: 4, p: 1}}>
                <Typography variant="h1" align="center" sx={{m: 0}}>{t("welcomeQuizTitle")}</Typography>
            </Paper>
            {
                !props.seenQuizHint &&
                <Hint handleHintClosed={props.setQuizHintSeen} hint={hint}/>
            }
            <Box sx={{display: "flex", justifyContent: "center", flexWrap: "wrap"}}>
                {renderQuizparts()}
            </Box>
        </Box>
    )
}